import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import RunContextProvider from "./Context/RunContextProvider";
import PrevDataProvider from "./Context/PrevDataProvider";
import ChatContextProvider from "./Context/ChatContextProvider";
import "./css/index.css";
import "./css/home.css";
import "./css/Editor.css";
import "./css/register.css";
import "./css/chat.css";
import "./css/repls.css";
import "./css/Responsive.css";
import LoadContextProvider from "./Context/LoadContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <LoadContextProvider>
      <RunContextProvider>
        <PrevDataProvider>
          <ChatContextProvider>
            <App />
          </ChatContextProvider>
        </PrevDataProvider>
      </RunContextProvider>
    </LoadContextProvider>
  </>
);
